import { IItemForGetShortInfo } from 'types';
import { TCreateTeaserSelectedItem } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React, { useCallback, useMemo } from 'react';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './RestaurantsField.module.scss';

interface IRestaurantsField {
	selectedRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	selectedCustomer: TCreateTeaserSelectedItem;
	setRestaurants: (value: string[]) => void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

const RestaurantsField: React.FC<IRestaurantsField> = ({
	selectedRestaurants,
	fetchedRestaurants,
	selectedCustomer,
	setRestaurants,
	setFetchedRestaurants,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const selectedItems: string[] = selectedRestaurants.filter((el) => el !== id);
			setRestaurants(selectedItems);
		},
		[selectedRestaurants, setRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return selectedRestaurants.map((el) => {
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [selectedRestaurants, fetchedRestaurants]);

	return (
		<div className={style.container} data-test="ModifierGroupField">
			<div className={style.field}>
				<RestaurantsMultipleSelect
					selectedRestaurants={selectedRestaurants}
					selectedCustomer={selectedCustomer}
					setRestaurants={setRestaurants}
					setFetchedRestaurants={setFetchedRestaurants}
				/>
			</div>
			<div className={style.groupsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(RestaurantsField);
